import React, { useRef } from 'react'

import { Icon, palette } from '@centivo/react-components'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import { useOnClickOutside, useToggle } from '_hooks'

import { BurgerMenu } from './BurgerMenu'

const List = styled.ul`
  position: absolute;
  width: 100vw;
  list-style: none;
  background-color: ${palette.neutral.white};
  top: 100%;
  right: 0;
  padding-right: 1rem;
  border-bottom: 1px solid ${palette.neutral['grey-bbbdbf']};
  box-shadow: 0 0.3125rem 0.375rem 0 rgb(187 189 191 / 60%);
`

const Item = styled.li`
  text-align: left;
  margin-right: auto;

  & a {
    display: block;
    font-size: 1.25rem;
    color: ${palette.neutral['grey-95989a']};
    line-height: 2.5rem;
    padding: 0.5rem;
    padding-left: 45%;

    & svg {
      color: inherit;
      margin-bottom: 0.25rem;
      margin-left: 0.25rem;
    }

    &.active,
    &:hover {
      color: ${palette.brand.teal};
    }
  }
`

export const ExpandableMenu = () => {
  const [open, toggleOpen, setOpen] = useToggle(false)
  const button = useRef<HTMLButtonElement>(null)
  const menu = useRef<HTMLUListElement>(null)

  useOnClickOutside(
    () => {
      setOpen(false)
    },
    [button, menu],
    []
  )
  const onSelectLink = () => setOpen(false)

  const label = open ? 'Close menu' : 'Open menu'

  return (
    <>
      <BurgerMenu
        ref={button}
        isActive={open}
        onClick={toggleOpen}
        aria-expanded={open}
        aria-label={label}
      />
      {open && (
        <List ref={menu}>
          <Item>
            <NavLink onClick={onSelectLink} to="/member-search">
              Member Search
            </NavLink>
          </Item>
          <Item>
            <NavLink onClick={onSelectLink} to="/referral-management">
              Referral Management
            </NavLink>
          </Item>
          <Item>
            <NavLink onClick={onSelectLink} to="/practice-profile">
              Practice Profile
            </NavLink>
          </Item>
          <Item>
            <NavLink onClick={onSelectLink} to="/practice-reports">
              Practice Reports
            </NavLink>
          </Item>
          <Item>
            <NavLink onClick={onSelectLink} to="/plan">
              Plan Resources
            </NavLink>
          </Item>
          <Item>
            <NavLink onClick={onSelectLink} to="/logout">
              Logout <Icon icon="log-out" />
            </NavLink>
          </Item>
        </List>
      )}
    </>
  )
}
